import React from 'react'
import FavoriteTours from './FavoriteTours'
import InnerBanner from './InnerBanner'

export default function About() {
  return (
    <>
    <InnerBanner />
    <FavoriteTours />
    </>
  )
}
